import { createContext } from 'react'

const ArtistContext = createContext()

export default ArtistContext
